<template>
  <div>
    <div class="header-tra-cuu">
      <span class="ml-3">Kế hoạch điều động tàu ngày {{searchTopTauAll}}</span>
    </div>
    <div style="display: flex;">
      <span style="margin: 8px 8px 0px 10px;">
        Ngày: 
      </span>
      <v-menu
        ref="menuTopTau"
        :close-on-content-click="false"
        v-model="menuTopTauAll"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        :style="{}"
        style="margin-top: 8px;"
        max-width="290px"
        min-width="290px"
        >
        <v-text-field
        slot="activator"
        v-model="searchTopTauAll"
        persistent-hint
        class="pb-0 my-0"
        ></v-text-field>
        <v-date-picker v-model="dateSearchTopTauAll" no-title @input="menuTopTauAll = false"></v-date-picker>
      </v-menu>
      <v-icon size="17" style="margin-left: 10px; cursor: pointer;" @click="menuTopTauAll = !menuTopTauAll">date_range</v-icon>

      <v-switch v-model="switch1" @change="changeTypePart" hide-details class="ml-4 mt-2"
      ></v-switch>
    </div>
    
    <div class="caption-header mt-3">
      Kế hoạch tàu đến cảng
    </div>
    
    <div class="mt-3" style="">
      <content-placeholders v-if="loadingTableTauDen">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
      <v-data-table
        v-else
        :headers="headersTauDenCang"
        :items="itemsDsTauDenCang"
        class="table-bordered danhSachHoSoTable__class"
        hide-actions
        :no-data-text="'Không tìm thấy hồ sơ '"
        :no-results-text="'Không tìm thấy hồ sơ '"
      >
        <template slot="headers" slot-scope="props">
          <tr style="background: #316BB6; color: #ffff;">
            <th style="color: #ffff !important; font-weight: normal !important;" v-for="header in props.headers" v-html="header.text">
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" style="width: 2%;">
            {{ props.index + 1 }}
          </td>
          <td v-if="itemKey.id !== 'stt'" class="text-xs-center" v-for="(itemKey, index) in headersTauDenCang">
            <span v-if="itemKey.id === 'chanelCodeList'">
              <div v-for="(item, index) in props.item[itemKey.display]" :key="'chanelCodeList' + index">{{item}}</div>
            </span>
            <span v-else-if="itemKey.id === 'pilotNames'">
              <div v-html="props.item[itemKey.display]"></div>
            </span>
            <span v-else-if="itemKey.id === 'tugBoatNames'">
              <div v-html="props.item[itemKey.display]"></div>
            </span>
            <span v-else>{{props.item[itemKey.display]}}</span>
          </td>
        </template>
      </v-data-table>
    </div>


    <div class="caption-header mt-3 mb-3">
      Kế hoạch tàu rời cảng
    </div>

    <content-placeholders v-if="loadingTableTauRoi">
      <content-placeholders-img />
      <content-placeholders-heading />
    </content-placeholders>

    <div class="mt-3" style="">
      <v-data-table
        :headers="headersTauRoiCang"
        :items="itemsDsTauRoiCang"
        class="table-bordered danhSachHoSoTable__class"
        hide-actions
        :no-data-text="'Không tìm thấy hồ sơ '"
        :no-results-text="'Không tìm thấy hồ sơ '"
      >
        <template slot="headers" slot-scope="props">
          <tr style="background: #316BB6; color: #ffff;">
            <th style="color: #ffff !important; font-weight: normal !important;" v-for="header in props.headers" v-html="header.text">
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" style="width: 2%;">
            {{ props.index + 1 }}
          </td>
          <td v-if="itemKey.id !== 'stt'" class="text-xs-center" v-for="(itemKey, index) in headersTauRoiCang">
            <span v-if="itemKey.id === 'chanelCodeList'">
              <div v-for="(item, index) in props.item[itemKey.display]" :key="'chanelCodeList' + index">{{item}}</div>
            </span>
            <span v-else-if="itemKey.id === 'pilotNames'">
              <div v-html="props.item[itemKey.display]"></div>
            </span>
            <span v-else-if="itemKey.id === 'tugBoatNames'">
              <div v-html="props.item[itemKey.display]"></div>
            </span>
            <span v-else>{{props.item[itemKey.display]}}</span>
          </td>
        </template>
      </v-data-table>
    </div>


    <div class="caption-header mt-3 mb-3">
      Kế hoạch tàu di chuyển
    </div>

    <div class="mt-3" style="">
      <content-placeholders v-if="loadingTableTauDiChuyen">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
      <v-data-table
        v-else
        :headers="headersTauDiChuyen"
        :items="itemsDsTauDiChuyen"
        class="table-bordered danhSachHoSoTable__class"
        hide-actions
        :no-data-text="'Không tìm thấy hồ sơ '"
        :no-results-text="'Không tìm thấy hồ sơ '"
      >
        <template slot="headers" slot-scope="props">
          <tr style="background: #316BB6;">
            <th style="color: #ffff !important; font-weight: normal !important;" v-for="header in props.headers" v-html="header.text">
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" style="width: 2%;">
            {{ props.index + 1 }}
          </td>
          <td v-if="itemKey.id !== 'stt'" class="text-xs-center" v-for="(itemKey, index) in headersTauDiChuyen">
            <span v-if="itemKey.id === 'chanelCodeList'">
              <div v-for="(item, index) in props.item[itemKey.display]" :key="'chanelCodeList' + index">{{item}}</div>
            </span>
            <span v-else-if="itemKey.id === 'pilotNames'">
              <div v-html="props.item[itemKey.display]"></div>
            </span>
            <span v-else-if="itemKey.id === 'tugBoatNames'">
              <div v-html="props.item[itemKey.display]"></div>
            </span>
            <span v-else>{{props.item[itemKey.display]}}</span>
          </td>
        </template>
      </v-data-table>
    </div>

  </div>
</template>
<script>
import supportData from '@/store/support.json'
export default {
  props: {
    type: '',
    documentTypeCode: '',
    documentStatusCode: '',
    stateDisplay: ''
  },
  components: {
  },
  provide: {
  },
  data: () => ({
    switch1: false,
    supportData: supportData,
    itemsDsTauDenCang: [],
    itemsDsTauRoiCang: [],
    itemsDsTauDiChuyen: [],
    groupOptions: { columns: ['anchoringPortHarbourName'] },
    searchTopTauAll: '',
    menuTopTauAll: false,
    dateSearchTopTauAll: '',
    headersTauDenCang: supportData.headersTauDenCang,
    headersTauRoiCang: supportData.headersTauRoiCang,
    headersTauDiChuyen: supportData.headersKHTauDiChuyen,
    loadingTableTauDen: false,
    loadingTableTauRoi: false,
    loadingTableTauDiChuyen: false,
    maritimeCode: 0
  }),
  watch: {
    '$route': function (newRoute, oldRoute) {
      let vm = this
      if (vm.code === 'KeHoachDieuDongTau2') {
        vm.switch1 = true
      } else {
        vm.switch1 = false
      }
    },
    dateSearchTopTauAll (val) {
      this.searchTopTauAll = this.parseDate(val)
      this.loadDataTauDenCang()
      this.loadDataTauRoiCang()
      this.loadDataTauDiChuyen()
    }
  },
  computed: {
  },
  created () {
    let vm = this
    // vm.loadDataTauDenCang()
    // vm.loadDataTauRoiCang()
    // vm.loadDataTauDiChuyen()
    vm.$store.dispatch('loadInitResource').then(function (result) {
      vm.loadMaritimeCode().then(result => {
        vm.getCurentDate()
        if (vm.code === 'KeHoachDieuDongTau2') {
          vm.switch1 = true
        } else {
          vm.switch1 = false
        }
      })
    })
  },
  methods: {
    loadMaritimeCode: function (query) {
      var vm = this
      let param = {
      }
      param['isDelete'] = 0
      param['start'] = -1
      param['end'] = -1
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0
            resolve(result[0])
          } else {
            resolve({})
          }
        }).catch(function (xhr) {
          console.log(xhr)
          reject(false)
        })
      })
    },
    changeTypePart () {
      let vm = this
      if (vm.maritimeCode === 18 || vm.maritimeCode === '18') {
        vm.switch1 = !vm.switch1
      }
      if (vm.switch1) {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau2'
        })
      } else {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau'
        })
      }
    },
    toDetailTauDen (item) {
      let vm = this
      vm.$store.dispatch('loadItineraryFromItineraryNo', {
        itineraryNo: item['itineraryNo']
      }).then(result => {
        vm.$store.dispatch('loadDetailHoSo', {
          documentName: result['documentNameIN'],
          documentYear: result['documentYearIN']
        }).then(resultHoSo => {
          if (result) {
            vm.$router.push({
              path: '/ho-so-phuong-tien/ke_hoach/' + result['documentNameIN'] + '/' + result['documentYearIN'] + '/' + resultHoSo['documentTypeCode'] + '/' + resultHoSo['requestState'] + '/DanhSachTauDenCang/' + item['vmaItineraryScheduleId']
            })
          }
        })
      }).catch(xhr => {
      })
    },
    toDetailTauRoi (item) {
      let vm = this
      vm.$store.dispatch('loadItineraryFromItineraryNo', {
        itineraryNo: item['itineraryNo']
      }).then(result => {
        vm.$store.dispatch('loadDetailHoSo', {
          documentName: result['documentNameOUT'],
          documentYear: result['documentYearOUT']
        }).then(resultHoSo => {
          if (result) {
            vm.$router.push({
              path: '/ho-so-phuong-tien/ke_hoach/' + result['documentNameOUT'] + '/' + result['documentYearOUT'] + '/' + resultHoSo['documentTypeCode'] + '/' + resultHoSo['requestState'] + '/DanhSachTauRoiCang/' + item['vmaItineraryScheduleId']
            })
          }
        })
      }).catch(xhr => {
      })
    },
    toDetailTauDiChuyen (item) {
      let vm = this
      vm.$store.dispatch('loadItineraryFromItineraryNo', {
        itineraryNo: item['itineraryNo']
      }).then(result => {
        vm.$store.dispatch('loadDetailHoSo', {
          documentName: result['documentNameIN'],
          documentYear: result['documentYearIN']
        }).then(resultHoSo => {
          if (result) {
            vm.$router.push({
              path: '/ho-so-phuong-tien/ke_hoach/' + result['documentNameIN'] + '/' + result['documentYearIN'] + '/' + resultHoSo['documentTypeCode'] + '/' + resultHoSo['requestState'] + '/DanhSachTauDiChuyen/' + item['vmaScheduleShiftingId']
            })
          }
        })
      }).catch(xhr => {
      })
    },
    getCurentDate () {
      let date = new Date()
      this.dateSearchTopTauAll = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    },
    mapNameData (data) {
      var vm = this
      return new Promise((resolve, reject) => {
        if (!data || !Array.isArray(data) || !data.length) {
          console.log('no data table!')
          resolve([])
          return
        }
        let dmAnchoringPortHarbourCode = []
        let dmAnchoringPortWharfCode = []
        let dmShiftingPortHarbourCode = []
        let dmShiftingPortWharfCode = []
        let dmShiftingPortRegionCode = []
        let dmLastPortHarbourCode = []
        let dmLastPortWharfCode = []
        let dmLastPortRegionCode = []
        let dmNextMaritimePortCode = []
        let dmNextPortRegionCode = []
        let dmNextPortHarbourCode = []
        let dmNextPortWharfCode = []
        let dmPortRegionCode = []
        let dmPortHarbourCode = []
        let dmPortWharfCode = []
        let dmShipTypeCode = []
        let dmFlagStateOfShip = []
        let dmNoticeShipType = []
        let dmChanelCodeList = []
        let dmShipAgencyCode = []
        let dmCargoCategory = []
        let dmCargo = []
        let dmShipOperator = []
        let dmShipOwner = []
        let actions = []
        for (var i = 0; i < data.length; i++) {
          if (data[i].hasOwnProperty('shipOperatorCode') && data[i].shipOperatorCode && (!data[i].hasOwnProperty('shipOperatorName') || !data[i]['shipOperatorName'])) {
            dmShipOperator.push({
              code: data[i]['shipOperatorCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('shipOwnerCode') && data[i].shipOwnerCode && (!data[i].hasOwnProperty('shipOwnerName') || !data[i]['shipOwnerName'])) {
            dmShipOwner.push({
              code: data[i]['shipOwnerCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('shipAgencyCode') && data[i].shipAgencyCode && (!data[i].hasOwnProperty('shipAgencyName') || !data[i]['shipAgencyName'])) {
            dmShipAgencyCode.push({
              code: data[i]['shipAgencyCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('cargoCode') && data[i].cargoCode && (!data[i].hasOwnProperty('cargoName') || !data[i]['cargoName'])) {
            dmCargo.push({
              code: data[i]['cargoCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('cargoCategory') && data[i].cargoCategory && (!data[i].hasOwnProperty('cargoCategoryName') || !data[i]['cargoCategoryName'])) {
            dmCargoCategory.push({
              code: data[i]['cargoCategory'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('chanelCodeList') && data[i].chanelCodeList) {
            dmChanelCodeList.push({
              code: data[i]['chanelCodeList'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('flagStateOfShip') && data[i].flagStateOfShip) {
            dmFlagStateOfShip.push({
              code: data[i]['flagStateOfShip'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('noticeShipType') && data[i].noticeShipType) {
            dmNoticeShipType.push({
              code: data[i]['noticeShipType'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('anchoringPortHarbourCode') && data[i].anchoringPortHarbourCode) {
            dmAnchoringPortHarbourCode.push({
              code: data[i]['anchoringPortHarbourCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('anchoringPortWharfCode') && data[i].anchoringPortWharfCode) {
            dmAnchoringPortWharfCode.push({
              code: data[i]['anchoringPortWharfCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('shiftingPortHarbourCode') && data[i].shiftingPortHarbourCode) {
            dmShiftingPortHarbourCode.push({
              code: data[i]['shiftingPortHarbourCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('shiftingPortWharfCode') && data[i].shiftingPortWharfCode) {
            dmShiftingPortWharfCode.push({
              code: data[i]['shiftingPortWharfCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('shiftingPortRegionCode') && data[i].shiftingPortRegionCode) {
            dmShiftingPortRegionCode.push({
              code: data[i]['shiftingPortRegionCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('lastPortHarbourCode') && data[i].lastPortHarbourCode) {
            dmLastPortHarbourCode.push({
              code: data[i]['lastPortHarbourCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('lastPortWharfCode') && data[i].lastPortWharfCode) {
            dmLastPortWharfCode.push({
              code: data[i]['lastPortWharfCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('lastPortRegionCode') && data[i].lastPortRegionCode) {
            dmLastPortRegionCode.push({
              code: data[i]['lastPortRegionCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('nextMaritimePortCode') && data[i].nextMaritimePortCode) {
            dmNextMaritimePortCode.push({
              code: data[i]['nextMaritimePortCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('nextPortRegionCode') && data[i].nextPortRegionCode) {
            dmNextPortRegionCode.push({
              code: data[i]['nextPortRegionCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('nextPortHarbourCode') && data[i].nextPortHarbourCode) {
            dmNextPortHarbourCode.push({
              code: data[i]['nextPortHarbourCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('nextPortWharfCode') && data[i].nextPortWharfCode) {
            dmNextPortWharfCode.push({
              code: data[i]['nextPortWharfCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('portRegionCode') && data[i].portRegionCode) {
            dmPortRegionCode.push({
              code: data[i]['portRegionCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('portHarbourCode') && data[i].portHarbourCode) {
            dmPortHarbourCode.push({
              code: data[i]['portHarbourCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('portWharfCode') && data[i].portWharfCode) {
            dmPortWharfCode.push({
              code: data[i]['portWharfCode'],
              index: i
            })
          }
          if (data[i].hasOwnProperty('shipTypeCode') && data[i].shipTypeCode) {
            dmShipTypeCode.push({
              code: data[i]['shipTypeCode'],
              index: i
            })
          }
        }
        if (dmAnchoringPortHarbourCode.length) {
          let codeArr = dmAnchoringPortHarbourCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortHarbour, index) => {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['anchoringPortHarbourCode']) {
                    data[index]['anchoringPortHarbourName'] = itemRes['portHarbourNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmAnchoringPortWharfCode.length) {
          let codeArr = dmAnchoringPortWharfCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_WHARF',
            portWharfCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortWharf, index) => {
                  if (itemRes['portWharfCode'] === itemPortWharf['anchoringPortWharfCode']) {
                    data[index]['anchoringPortWharfName'] = itemRes['portWharfNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmShiftingPortHarbourCode.length) {
          let codeArr = dmShiftingPortHarbourCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortHarbour, index) => {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['shiftingPortHarbourCode']) {
                    data[index]['shiftingPortHarbourName'] = itemRes['portHarbourNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmShiftingPortWharfCode.length) {
          let codeArr = dmShiftingPortWharfCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_WHARF',
            portWharfCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortWharf, index) => {
                  if (itemRes['portWharfCode'] === itemPortWharf['shiftingPortWharfCode']) {
                    data[index]['shiftingPortWharfName'] = itemRes['portWharfNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmShiftingPortRegionCode.length) {
          let codeArr = dmShiftingPortRegionCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_REGION',
            portRegionCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortRegion, index) => {
                  if (itemRes['portRegionCode'] === itemPortRegion['shiftingPortRegionCode']) {
                    data[index]['shiftingPortRegionName'] = itemRes['portRegionNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmLastPortHarbourCode.length) {
          let codeArr = dmLastPortHarbourCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortHarbour, index) => {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['lastPortHarbourCode']) {
                    data[index]['lastPortHarbourName'] = itemRes['portHarbourNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmLastPortWharfCode.length) {
          let codeArr = dmLastPortWharfCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_WHARF',
            portWharfCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortWharf, index) => {
                  if (itemRes['portWharfCode'] === itemPortWharf['lastPortWharfCode']) {
                    data[index]['lastPortWharfName'] = itemRes['portWharfNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmLastPortRegionCode.length) {
          let codeArr = dmLastPortRegionCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_REGION',
            portRegionCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortRegion, index) => {
                  if (itemRes['portRegionCode'] === itemPortRegion['lastPortRegionCode']) {
                    data[index]['lastPortRegionName'] = itemRes['portRegionNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmNextMaritimePortCode.length) {
          let codeArr = dmNextMaritimePortCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_MARITIME',
            maritimeCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemMaritime, index) => {
                  if (itemRes['maritimeCode'] === itemMaritime['nextMaritimePortCode']) {
                    data[index]['nextMaritimePortName'] = itemRes['maritimeNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmNextPortRegionCode.length) {
          let codeArr = dmNextPortRegionCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portRegionCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortRegion, index) => {
                  if (itemRes['portRegionCode'] === itemPortRegion['nextPortRegionCode']) {
                    data[index]['nextPortRegionName'] = itemRes['portRegionNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmNextPortHarbourCode.length) {
          let codeArr = dmNextPortHarbourCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortHarbour, index) => {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['nextPortHarbourCode']) {
                    data[index]['nextPortHarbourName'] = itemRes['portHarbourNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmNextPortWharfCode.length) {
          let codeArr = dmNextPortWharfCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portWharfCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortWharf, index) => {
                  if (itemRes['portWharfCode'] === itemPortWharf['nextPortWharfCode']) {
                    data[index]['nextPortWharfName'] = itemRes['portWharfNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmPortRegionCode.length) {
          let codeArr = dmPortRegionCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portRegionCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortRegion, index) => {
                  if (itemRes['portRegionCode'] === itemPortRegion['portRegionCode']) {
                    data[index]['portRegionName'] = itemRes['portRegionNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmPortHarbourCode.length) {
          let codeArr = dmPortHarbourCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portHarbourCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortHarbour, index) => {
                  if (itemRes['portHarbourCode'] === itemPortHarbour['portHarbourCode']) {
                    data[index]['portHarbourName'] = itemRes['portHarbourNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmPortWharfCode.length) {
          let codeArr = dmPortWharfCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            portWharfCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemPortHarWharf, index) => {
                  if (itemRes['portWharfCode'] === itemPortHarWharf['portWharfCode']) {
                    data[index]['portWharfName'] = itemRes['portWharfNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmShipTypeCode.length) {
          let codeArr = dmShipTypeCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_PORT_HARBOUR',
            shipTypeCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemShipType, index) => {
                  if (itemRes['shipTypeCode'] === itemShipType['shipTypeCode']) {
                    data[index]['shipTypeName'] = itemRes['shipTypeNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmFlagStateOfShip.length) {
          let codeArr = dmFlagStateOfShip.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_STATE',
            stateCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemShipType, index) => {
                  if (itemRes['stateCode'] === itemShipType['flagStateOfShip']) {
                    data[index]['flagStateOfShipName'] = itemRes['stateName']
                  }
                })
              })
            }
          }))
        }
        if (dmShipAgencyCode.length) {
          let codeArr = dmShipAgencyCode.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_SHIP_AGENCY',
            shipAgencyCode: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemShipAgency, index) => {
                  if (itemRes['shipAgencyCode'] === itemShipAgency['shipAgencyCode']) {
                    data[index]['shipAgencyName'] = itemRes['shipAgencyNameVN']
                  }
                })
              })
            }
          }))
        }
        if (dmChanelCodeList.length) {
          let codeArr = dmChanelCodeList.map(item => {
            data[item['index']]['chanelCodeListName'] = []
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_TUYEN_LUONG',
            code: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemChanelCodeList, index) => {
                  if (itemChanelCodeList['chanelCodeList']) {
                    let chanelCodeListTmp = itemChanelCodeList['chanelCodeList'].split(',')
                    for (var i = 0; i < chanelCodeListTmp.length; i++) {
                      if (itemRes['code'] === chanelCodeListTmp[i]) {
                        data[index]['chanelCodeListName'].push(itemRes['name'])
                      }
                    }
                  }
                })
              })
            }
          }))
        }
        if (dmNoticeShipType.length) {
          vm.itemsSup['noticeShipTypeItems'].forEach(itemRes => {
            data.forEach((itemNoticeShipType, index) => {
              if (itemRes['itemValue'] === itemNoticeShipType['noticeShipType'].toString()) {
                data[index]['noticeShipTypeName'] = itemRes['itemText']
              }
            })
          })
        }
        if (dmCargoCategory.length) {
          let codeArr = dmCargoCategory.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItem_2Name({
            dataGroupId: '119',
            code: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemCargoCategory, index) => {
                  if (itemRes['code'] === itemCargoCategory['cargoCategory']) {
                    data[index]['cargoCategoryName'] = itemRes['name']
                  }
                })
              })
            }
          }))
        }
        if (dmCargo.length) {
          let codeArr = dmCargo.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_DATAITEM_GROUP124',
            code: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemCargo, index) => {
                  if (itemRes['code0'] === itemCargo['cargoCode']) {
                    data[index]['cargoName'] = itemRes['name']
                  }
                })
              })
            }
          }))
        }
        if (dmShipOperator.length) {
          let codeArr = dmShipOperator.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_VMA_SHIP_OWNER',
            isShipOperator: 1,
            code: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemShipOperator, index) => {
                  if (itemRes['shipOwnerCode'] === itemShipOperator['shipOperatorCode']) {
                    data[index]['shipOperatorName'] = itemRes['companyName']
                  }
                })
              })
            }
          }))
        }
        if (dmShipOwner.length) {
          let codeArr = dmShipOwner.map(item => {
            return item.code
          }).join(',')
          actions.push(vm.getDmItemName({
            categoryId: 'DM_VMA_SHIP_OWNER',
            isShipOwner: 1,
            code: codeArr
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              result.forEach(itemRes => {
                data.forEach((itemShipOwner, index) => {
                  if (itemRes['shipOwnerCode'] === itemShipOwner['shipOwnerCode']) {
                    data[index]['shipOwnerName'] = itemRes['companyName']
                  }
                })
              })
            }
          }))
        }
        vm.loadingTableAlll = true
        Promise.all(actions).then(results => {
          vm.loadingTableAlll = false
          for (var i = 0; i < data.length; i++) {
            if (data[i].hasOwnProperty('chanelCodeList') && data[i].chanelCodeList) {
              if (typeof data[i].chanelCodeList === 'string') {
                data[i]['chanelCodeList'] = data[i]['chanelCodeList'].split(',')
              }
            } else if (data[i].hasOwnProperty('chanelCodeList') && !data[i].chanelCodeList) {
              data[i]['chanelCodeList'] = []
            }
          }
          console.log('data+++++++++', data)
          resolve(data)
        }).catch(xhr => {
          console.log('data______table____error=======>>>>>>>', xhr)
          reject(xhr)
        })
      })
    },
    getDmItem_2Name: function (data) {
      var vm = this
      if (!data) {
        console.log('valid data param!!!!!!!')
        return
      }
      let param = {}
      if (data) {
        for (var key in data) {
          param[key] = data[key]
        }
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loadDataItems', param).then(function (result) {
          resolve(result)
        }).catch(function (xhr) {
          console.log(xhr)
          reject(xhr)
        })
      })
    },
    getDmItemName: function (data) {
      var vm = this
      if (!data) {
        console.log('valid data param!!!!!!!')
        return
      }
      let param = {}
      if (data) {
        for (var key in data) {
          param[key] = data[key]
        }
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loadDataDm', param).then(function (result) {
          resolve(result)
        }).catch(function (xhr) {
          console.log(xhr)
          reject(xhr)
        })
      })
    },
    parseDate (date) {
      if (!date) return null
      console.log(date)
      const [year, month, day] = date.split('-')
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
    },
    loadDataTauDenCang () {
      let vm = this
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        let url = resultInit['getVmaItinerarySchedule_Come_URL']
        vm.loadingTableTauDen = true
        vm.$store.dispatch('loadDanhSachTauBien', {
          url: url,
          start: -1,
          end: -1,
          noticeShipType: 1,
          maritimeCode: vm.maritimeCode,
          markedAsArrival: '3,4,5,7,8,9',
          shipBoat: 'SHIP',
          timeOfArrival: vm.searchTopTauAll
        }).then(result => {
          if (result && !result.hasOwnProperty('errorCode')) {
            vm.loadingTableTauDen = false
            vm.itemsDsTauDenCang = result['data']
          } else {
            vm.itemsDsTauDenCang = []
            vm.loadingTableTauDen = false
          }
        }).catch(xhr => {
          vm.loadingTableTauDen = false
        })
      })
    },
    loadDataTauRoiCang () {
      let vm = this
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        let url = resultInit['getVmaItinerarySchedule_Leave_URL']
        vm.loadingTableTauRoi = true
        vm.$store.dispatch('loadDanhSachTauBien', {
          url: url,
          start: -1,
          end: -1,
          noticeShipType: 2,
          shipBoat: 'SHIP',
          maritimeCode: vm.maritimeCode,
          markedAsDeparture: '3,4,5,7,8,9',
          timeOfDeparture: vm.searchTopTauAll
        }).then(result => {
          if (result && !result.hasOwnProperty('errorCode')) {
            vm.loadingTableTauRoi = false
            vm.itemsDsTauRoiCang = result['data']
          } else {
            vm.itemsDsTauRoiCang = []
            vm.loadingTableTauRoi = false
          }
        })
      })
    },
    loadDataTauDiChuyen () {
      let vm = this
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        let url = resultInit['getVmaScheduleShiftingURL']
        vm.loadingTableTauDiChuyen = true
        vm.$store.dispatch('loadDanhSachTauBien', {
          url: url,
          start: -1,
          end: -1,
          maritimeCode: vm.maritimeCode,
          requestState: 4,
          noticeShipType: 4,
          shiftingDate: vm.searchTopTauAll
        }).then(result => {
          if (result && !result.hasOwnProperty('errorCode')) {
            vm.loadingTableTauDiChuyen = false
            vm.itemsDsTauDiChuyen = result['data'] || []
          } else {
            vm.itemsDsTauDiChuyen = []
            vm.loadingTableTauDiChuyen = false
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// KeHoachDieuDongTau.vue?0e941efd